import { Component, Input, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { cn } from '../../lib/utils';

@Component({
  selector: 'app-avatar',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './avatar.component.html',
})
export class AvatarComponent {
  @Input() className: string = '';
  showFallback = signal(true);

  get classes() {
    return cn('relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full', this.className);
  }
}
